import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from 'react-router-dom';

//Router
import {
    Route,
    Switch
} from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

//Controllers

import { headerSearch, tabs, unoTheme } from '../../../../assets/styles/unoTheme';

import PrintIcon from '@material-ui/icons/Print';
import { MyTab, MyTabs } from "../../../utils/MyTabs";
import UnoButton from '../../../utils/UnoButton';
import { path } from "../../../utils/routesPaths";
import AlocationAssetsTab from './tabs/AlocationAssetsTab';
import { groupAssetTitles } from '../../../../controllers/TitleController';
import { getSegmentKeyById, getSimpleNormalizedAssets } from '../../../../controllers/AssetsController';
import { useCallback } from 'react';
import { applyMaskAmount, checkPortfolioIsOutArticles, formatTextForValidDisplay, getFirstAndEndDateByMonthAndYear, getLastDayInMonthByMonthAndYear, getLastDayMonth, getMonthAndYearPortfolioClosed, getStartDateAndEndDateByMonthYear, getTitleCod, groupArticlePolicys, groupByDistributionOptions, markArticlesInPortfolio, parseFloatByPtCurrency, pureConsoleLog } from '../../../utils/utils';
import allActions from '../../../../actions';
import DistribuitionAssetsTab from './tabs/DistribuitionAssetsTab';
import ArticlesTableTab from './tabs/ArticlesTableTab';
import { AccountAPI } from '../../../../API/account';
import CommentsTab from './tabs/CommentsTab';
import { distributionOptionClassification, order, sortTableRows } from '../../../utils/distribution';
import { LegislationArticleAPI } from '../../../../API/legislation_article';
import { ArticleRulesAPI } from '../../../../API/article_rules';
import AddIcon from '@material-ui/icons/Add';
import AddFundAlocationModal from './modals/AddFundAlocationModal';
import VMasker from 'vanilla-masker';
import { Badge } from '@material-ui/core';
import { AssetsAPI } from '../../../../API/assets';

const {
    benchmark_anbima,
} = distributionOptionClassification;

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },
    bottomTabs: {
        height: '24px',
        width: '100%',
        background: unoTheme.menuContent,
    },
    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '16px',
        alignItems: 'center',
        justifyContent: 'space-between',

        '& .MuiToggleButtonGroup-root': {
            alignItems: 'center',

            '& .MuiToggleButton-label': {
                whiteSpace: 'nowrap'
            }
        }
    },

    flexCenterDiv: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    rightHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: "12px",
        '& .ipc14-components': {
            display: 'flex',
            alignItems: 'center',
            gap: "12px",
        }
    },

    outArticlesBadge: {
        '& .MuiBadge-badge': {
            marginRight: "-10px !important",
            backgroundColor: "red !important"
        }
    }
});

export default function AlocationScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)
    const [tabValue, setTabValue] = useState(null);

    const [clientOnScreen, setClientOnScreen] = useState(undefined);

    const [month, setMonth] = useState(undefined);
    const [year, setYear] = useState(undefined);

    //Assets
    const [assetsLoading, setAssetsLoading] = React.useState(true);
    const [assetsFormatted, setAssetsFormatted] = React.useState([]);
    const [totalBalanceNow, setTotalBalanceNow] = useState(0);
    const [totalDisponibilityInAccounts, setTotalDisponibilityInAccounts] = useState();
    const [noAssets, setNoAssets] = useState(false);

    const [addedFunds, setAddedFunds] = useState([]);


    //Distribuition
    const [dataToTableDistribuition, setDataToTableDistribuition] = useState([]);

    //Articles
    const [legislationArticles, setListLegislationArticles] = useState([]);

    //Comments
    const [comments, setComments] = useState('');

    const handleChangeTabValue = (event, newValue) => {

        setTabValue(newValue);

        if (newValue == 0) {
            history.push(path.administrative.alocation.assets)
        } else if (newValue == 1) {
            history.push(path.administrative.alocation.benchmarks)
        } else if (newValue == 2) {
            history.push(path.administrative.alocation.articles)
        } else if (newValue == 3) {
            history.push(path.administrative.alocation.annotations)
        }

    };

    useEffect(() => {
        if (!clientOn?.client?.id) return;
        handleChangeTabValue(null, 0)
    }, [])

    const loadInfosAssets = useCallback(async (clientId, month, year, doQuotas, promanagementCode) => {

        setAssetsLoading(true);
        setAssetsFormatted([]);
        setValuesByIndex({});

        console.log("PASSANFO LOAD INFOS ASSETS: ", clientId,
            month,
            year);

        //Caso o month e o year sejam undefined (quando ainda não existem movimentações cadastradas)
        //dentro do percusso desse método deve se parar no momento em que trás as contas
        //let responseInfosAssets = await getAssetInfos(clientId, month, year, null, doQuotas);
        // const responseInfosAssets = await getSimpleNormalizedAssets(clientId,
        //     month,
        //     year,
        //     null)
        const responseInfosAssets = await AssetsAPI.getSimpleNormalizedAssets(clientId,
            month,
            year,
            null)

        console.log("### INFO ASSETS: ", responseInfosAssets);
        if (responseInfosAssets.success) {

            //setResolutionName(responseInfosAssets.resolutionName);
            const { assets } = responseInfosAssets;

            const formattedAssets = groupAssetTitles(assets)

            const responseDisponibility = await AccountAPI.getDisponilityByMonthAndYear(clientId, month, year);

            console.log("responseDisponibility: ", responseDisponibility);

            setTotalDisponibilityInAccounts(parseFloat(responseDisponibility.body[0].balance));

            setAssetsFormatted(formattedAssets);

            //initNewInputs(formattedAssets);

            setTotalBalanceNow(responseInfosAssets.totalBalanceNow);

            initNewInputs(formattedAssets);

            setAssetsLoading(false);


        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: responseInfosAssets.message,
            }))

        }

        console.log("responseInfosAssets: ", responseInfosAssets);
        if (responseInfosAssets && responseInfosAssets.assets.length == 0) {

            //setInnerLoad("Nenhum ativo encontrado");

            setNoAssets(true)
        } else {
            //setInnerLoad(null);
        }



    }, [])

    const [valuesByIndex, setValuesByIndex] = useState({});

    const newTotalBalance = useMemo(() => {

        return Object.values(valuesByIndex).reduce((acc, curr) => acc + curr.newBalanceNow, 0);

    }, [valuesByIndex])

    const newParticipations = useMemo(() => {
        const participations = [];

        Object.values(valuesByIndex).forEach((values) => {
            const { newBalanceNow } = values;
            participations.push((newBalanceNow / newTotalBalance) * 100);
        });

        return participations;
    }, [valuesByIndex, newTotalBalance]);


    const getDefaultValueInput = (balanceNow, applications, rescues) => ({

        applications: applications ?? "0,00",
        rescues: rescues ?? "0,00",
        newBalanceNow: balanceNow,

    });
    const initNewInputs = (assetsFormatted) => {

        const current = {};
        assetsFormatted.forEach((element, index) => {
            current[index] = getDefaultValueInput(element.balance_now);
        });
        setValuesByIndex(current);
    }

    const handleChangeValuesByIndex = (index, value, type) => {

        const current = { ...valuesByIndex };

        const asset = assetsFormatted[index];

        current[index][type] = value;

        const { applications, rescues } = current[index];

        const floatedApplication = parseFloatByPtCurrency(applications);
        const floatedRescues = parseFloatByPtCurrency(rescues);

        console.log(asset.balance_now, applications, rescues);

        current[index].newBalanceNow = asset.balance_now + floatedApplication - floatedRescues;

        setValuesByIndex(current);


    }

    const assetsWithNewValues = useMemo(() => {
        if (!assetsFormatted.length || !Object.keys(valuesByIndex).length) return;
        //console.log("valuesByIndex: ", valuesByIndex);
        return assetsFormatted.map((el, index) => ({
            ...el,
            balance_now: valuesByIndex[index]?.newBalanceNow ?? 0,
        }))
    }, [assetsFormatted, valuesByIndex])

    const getCurrentExtraPolicy = (policy, selectedMonth, theTargetCode) => {

        if (!policy.extrasPolicys) return "-";
        if (policy.extrasPolicys[selectedMonth]) return policy.extrasPolicys[selectedMonth][theTargetCode] + "%";

        for (let index = (selectedMonth - 1); index >= 1; index--) {
            const stringMonth = index.toString();
            if (policy.extrasPolicys[stringMonth]?.[theTargetCode]) return policy.extrasPolicys[stringMonth][theTargetCode] + "%";

        }

        return "-";
    }

    const doReport = (assets, values, participations, articles, dataToChart, dataToTable) => {

        console.log("isArticlesOut: ", isArticlesOut);
        if (isArticlesOut) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'Existem desenquadramentos apontados na atual configuração de alocação'
            }))
            //return;
        }
        console.log("##### REPORT");
        const formattedAssetsToPdf = [];
        assets.forEach((row, index) => {
            formattedAssetsToPdf.push({
                asset: row.title_id != null ? getTitleCod(row) : row.fund_name,
                balanceNow: row.balance_now != undefined ?
                    applyMaskAmount(row.balance_now, true)
                    : 'Não informado',
                rescues: applyMaskAmount(parseFloatByPtCurrency(values?.[index]?.rescues), true),
                applications: applyMaskAmount(parseFloatByPtCurrency(values?.[index]?.applications), true),
                newBalanceNow: values?.[index]?.newBalanceNow != null ? applyMaskAmount(values?.[index]?.newBalanceNow, true) : "-",
                participation: row.participation + "%",
                newParticipation: participations?.[index] != null ? applyMaskAmount(participations[index]) + "%" : "-",
                deviceAbreviation: row.device_abbreviation ? row.device_abbreviation : '-',
                addedFund: row.addedFund,


            })
        });
        //Total investiments
        formattedAssetsToPdf.push({
            asset: "Total investimentos",
            balanceNow: applyMaskAmount(totalBalanceNow, true),
            rescues: '-',
            applications: "-",
            newBalanceNow: applyMaskAmount(newTotalBalance, true),
            participation: "100%",
            newParticipation: "100%",
            deviceAbreviation: '-',

        })
        //Disponibilidades
        formattedAssetsToPdf.push({
            asset: "Disponibilidade",
            balanceNow: applyMaskAmount(totalDisponibilityInAccounts, true),
            rescues: '-',
            applications: "-",
            newBalanceNow: applyMaskAmount(totalDisponibilityInAccounts, true),
            participation: "-",
            newParticipation: "-",
            deviceAbreviation: '-',

        })
        //Total assets
        formattedAssetsToPdf.push({
            asset: "Total patrimônio",
            balanceNow: applyMaskAmount(totalBalanceNow, true),
            rescues: '-',
            applications: "-",
            newBalanceNow: applyMaskAmount(newTotalBalance, true),
            participation: "-",
            newParticipation: "-",
            deviceAbreviation: '-',

        })
        console.log("formattedAssetsToPdf: ", formattedAssetsToPdf);
        console.log("Articles: ", articles.filter(el => el.isInPortfolio));
        const formattedArticles = articles.filter(el => el.isInPortfolio).map((row) => ({
            asset: row.asset,
            segment: row.segment,
            limitResolution: applyMaskAmount(row.limit_resolution) + "%",
            portfolioPorcent: applyMaskAmount(row.totalArticleValue * 100 / totalPortfolioBalance) + "%",
            portfolioValue: applyMaskAmount(row.totalArticleValue, true),
            lowTarget: row.extrasPolicys ? getCurrentExtraPolicy(row, month, 'lower_target') ?? '-' : row.lower_target ? row.lower_target + '%' : '-',
            target: row.extrasPolicys ? getCurrentExtraPolicy(row, month, 'target') ?? '-' : row.target ? row.target + '%' : '-',
            topTarget: row.extrasPolicys ? getCurrentExtraPolicy(row, month, 'top_target') ?? '-' : row.top_target ? row.top_target + '%' : '-',
            segmentId: row.legislation_segment_id,
        }))

        //Agrupamento pela chave do segmento e não pelo id, pois cada versão da resolução
        //possui seus próprios ids de legislation_segments (3.922: 1-3, 4.963: 4-9, 5.272: 11-16)
        const segmentLabelsByKey = {
            RENDA_FIXA: "Renda Fixa",
            RENDA_VARIAVEL: "Renda Variável",
            EXTERIOR: "Exterior",
            ESTRUTURADOS: "Estruturados",
            IMOBILIARIOS: "Fundos Imobiliários",
            CONSIGNADO: "Emprést. Consignado",
        }

        const groupedFormattedArticles = [];
        Object.entries(segmentLabelsByKey).map(([segmentKey, label]) => {

            const filtered = formattedArticles.filter((el) => getSegmentKeyById(Number(el.segmentId)) === segmentKey);
            if (filtered.length) {
                groupedFormattedArticles.push({
                    asset: label,
                    segment: "SEGMENT",
                    limitResolution: "",
                    portfolioPorcent: "",
                    portfolioValue: "",
                    lowTarget: "",
                    target: "",
                    topTarget: "",
                    segmentId: "",
                });
                groupedFormattedArticles.push.apply(groupedFormattedArticles, filtered);
            }
        })

        groupedFormattedArticles.push({
            asset: "Total",
            segment: "TOTAL",
            limitResolution: "",
            portfolioPorcent: "100%",
            portfolioValue: applyMaskAmount(newTotalBalance, true),
            lowTarget: "",
            target: "",
            topTarget: "",
            segmentId: "",
        });

        const { endDate } = getFirstAndEndDateByMonthAndYear(month, year);
        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType: 'alocation',
            referenceDate: endDate,
            reportData: {
                assets: formattedAssetsToPdf,
                articles: groupedFormattedArticles,
                distribuition: {
                    dataToChart,
                    dataToTable
                },
                comments: comments,
            },
            message: 'Gerando sugestão de alocação...'
        }))

    }

    //Distribuition

    const [dataToTable, setDataToTable] = useState([]);
    const [dataToChart, setDataToChart] = useState([]);
    const [totalLine, setTotalLine] = useState(0);
    const defaultOrder = order.getColumn(order.ASC, 2);
    const [columnOrder, setColumnOrder] = useState(defaultOrder);


    const endDayPortfolioPeriodSelected = useMemo(() => {
        if (month && year) {

            return getLastDayMonth(month, year)
        }
        return null;
    }, [month, year])

    /**
     * 
     * @param {Array} assets
     * @param {String} selectedOption {@link distributionOptionClassification}
     * @param {Boolean} justTwoWords
     * @param {String} columnOrder {@link order}
     * @returns 
     */
    function handleGroupByDistributionOptions(assets, selectedOption, justTwoWords, columnOrder, endDayPeriod) {

        console.log("handleGroupByDistributionOptions: ", assets, selectedOption, justTwoWords, columnOrder, endDayPeriod);
        let { dataToFormat, dataToChart, dataToTable } = groupByDistributionOptions(assets, selectedOption, justTwoWords, columnOrder, endDayPeriod);
        let { totalAmount, assetClasses } = dataToFormat;

        let indexToColor = 0;
        Object.entries(assetClasses).map(([label, row]) => {
            row.formatedLabel = label;
            if (justTwoWords) row.formatedLabel = formatTextForValidDisplay(label, 2);
            row.formatedAmount = applyMaskAmount(row.amount, true);
            row.legColor = unoTheme.chartColors[indexToColor];

            indexToColor++;

            dataToTable.data.push(row);
        });

        setTotalLine(totalAmount);

        if (dataToTable.data && dataToTable.data.length > 0) {
            let sortedDataToTable = sortTableRows(columnOrder, dataToTable.data);
            dataToTable.data = sortedDataToTable;

            setDataToTable(dataToTable);
        }

        setDataToChart(dataToChart);
    }


    useEffect(() => {

        if (!assetsWithNewValues?.length) return;
        handleGroupByDistributionOptions(assetsWithNewValues, benchmark_anbima, true, columnOrder, endDayPortfolioPeriodSelected);

    }, [assetsWithNewValues, clientOn]);

    //Articles

    const [legislationSegments, setListLegislationSegments] = useState([]);
    //Total dos saldos da carteira
    const [totalPortfolioBalance, setTotalPortfolioBalance] = useState(null);
    //Total dos saldos dos artigos do segmento específico (Ex: fundos de renda fixa)
    const [totalArticlesBalance, setTotalArticlesBalance] = useState(null);
    const [isArticlesOut, setIsArticlesOut] = useState(false);

    //AssetsByRule
    const [assetsByRule, setAssetsByRule] = useState();
    async function loadArticles(assetsFormatted, month, yearToSelect) {


        setArticlesLoading(true);

        const responseProccessArticles = await LegislationArticleAPI.proccessAndCheckNonComplienceArticles(clientOn.client.id,
            assetsFormatted,
            month,
            yearToSelect,
            clientOn.client.promanagement_code);

        console.log("responseProccessArticles: ", responseProccessArticles);

        setTotalPortfolioBalance(responseProccessArticles.totalPortfolioValue);
        setTotalArticlesBalance(responseProccessArticles.totalArticlesValue);
        setAssetsByRule(responseProccessArticles.assetsByRule);
        setListLegislationArticles(responseProccessArticles.articles);
        setIsArticlesOut(responseProccessArticles.isArticlesOut);

        setArticlesLoading(false);

    }

    const [processingInformationsTimeout, setProcessingInformationsTimeout] = useState(null);
    const [articlesLoading, setArticlesLoading] = useState(null);

    const delayedChange = () => {
        if (!articlesLoading)
            setArticlesLoading(true);
        return setProcessingInformationsTimeout(setTimeout(() => {
            //realizar processamentos

            if (month && year) {
                loadArticles(assetsWithNewValues, month, year);
            }
        }, 1200));
    };

    //Add fund
    const [openAddFundAlocationModal, setOpenAddFundAlocationModal] = useState(false);
    const handleOpenAddFundAlocationModal = () => {
        setOpenAddFundAlocationModal(true);
    }

    const handleRemoveAddedFund = (indexToRemove) => {

        const current = [...assetsFormatted];
        current.splice(indexToRemove, 1);
        setAssetsFormatted(current);

        const currentValuesByIndex = { ...valuesByIndex };
        delete currentValuesByIndex[indexToRemove];
        setValuesByIndex(currentValuesByIndex);
    }
    const handleAddNewFund = (newFund, initApplication) => {
        console.log("newFund: ", newFund);
        newFund.addedFund = true;
        newFund.initAddedFundApplication = initApplication;
        newFund.balance_now = 0;
        newFund.participation = 0;

        const current = [...assetsFormatted];
        current.push(newFund);
        setAssetsFormatted(current);
        const currentValuesByIndex = { ...valuesByIndex };
        const ajustedValue = initApplication.toString().includes(".") ? initApplication.toString() : initApplication.toString() + ".00";
        const maskedValue = VMasker.toMoney(ajustedValue);
        console.log("initApplication: ", initApplication);
        console.log("maskedValue: ", maskedValue);
        currentValuesByIndex[current.length - 1] = {
            ...getDefaultValueInput(newFund.balance_now, maskedValue),
            newBalanceNow: initApplication,
        }
        setValuesByIndex(currentValuesByIndex);
    }

    // const isArticlesOut = useMemo(() => {

    //     if (!legislationArticles?.length) return;
    //     return checkPortfolioIsOutArticles(legislationArticles, totalPortfolioBalance);

    // }, [legislationArticles]);

    useEffect(() => {


        if (!clientOn?.client) return;
        if (!clientOn.client.portfolio_closed) {
            setNoAssets(true)
            return;
        }
        if (clientOn.client.id == clientOnScreen && assetsFormatted?.length !== 0) return;

        console.log("use effect assetsFormatted: ", assetsFormatted);

        handleChangeTabValue(null, 0)
        setClientOnScreen(clientOn.client.id)

        const portfolioClosed = clientOn.client.portfolio_closed;
        const { month, year } = getMonthAndYearPortfolioClosed(portfolioClosed);
        setMonth(month)
        setYear(year)

        loadInfosAssets(clientOn.client.id,
            month,
            year,
            false, clientOn.client.promanagement_code);
    }, [clientOn]);

    useEffect(() => {
        if (assetsWithNewValues?.length) {
            clearTimeout(processingInformationsTimeout)
            delayedChange();
        }
    }, [assetsWithNewValues])


    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>

                <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: "auto" }}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}>

                        <MyTab label="Ativos" />
                        <MyTab label="Benchmarks" disabled={assetsLoading} />
                        <MyTab
                            label={

                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>Enquadramentos
                                    {
                                        isArticlesOut &&
                                        <div style={{
                                            backgroundColor: "red",
                                            width: "18px",
                                            height: "18px",
                                            borderRadius: "50%",
                                            paddingLeft: "1px",
                                            color: "white",
                                            fontWeight: "bold",
                                            fontSize: "10px",
                                        }}><span>!</span>
                                        </div>
                                    }
                                </div>
                            }
                            disabled={assetsLoading}
                        />
                        <MyTab label="Anotações" disabled={assetsLoading} />

                    </MyTabs>

                </div>


                <div className={classes.rightHeader}>

                    {
                        tabValue === 0 && !assetsLoading &&
                        <UnoButton
                            size={'small'}
                            type='success'
                            startIcon={<AddIcon />}
                            onClick={() => handleOpenAddFundAlocationModal()}>
                            {"Adicionar fundo"}
                        </UnoButton>
                    }

                    <UnoButton
                        style={{ marginRight: '16px' }}
                        size={'small'}
                        disabled={assetsLoading || assetsFormatted?.length === 0 || articlesLoading}
                        //disabled={true}
                        type='primary'
                        startIcon={<PrintIcon />}
                        onClick={() => doReport(assetsFormatted, valuesByIndex, newParticipations, legislationArticles, dataToChart, dataToTable)}>
                        {"Relatório de Alocação"}
                    </UnoButton>

                </div>


            </div>
            <Switch className={classes.switch}>
                <Route path={path.administrative.alocation.assets}>
                    <AlocationAssetsTab assetsFormatted={assetsFormatted}
                        totalBalanceNow={totalBalanceNow}
                        disponibility={totalDisponibilityInAccounts}
                        month={month}
                        year={year}
                        valuesByIndex={valuesByIndex}
                        newParticipations={newParticipations}
                        newTotalBalance={newTotalBalance}
                        handleChangeValuesByIndex={handleChangeValuesByIndex}
                        noAssets={noAssets}
                        isLoading={assetsLoading}
                        handleRemoveAddedFund={handleRemoveAddedFund} />
                </Route>
                <Route path={path.administrative.alocation.benchmarks}>
                    <DistribuitionAssetsTab
                        assets={assetsWithNewValues}
                        valuesByIndex={valuesByIndex}
                        newTotalBalance={newTotalBalance}
                        isLoading={assetsLoading}
                        dataToTable={dataToTable}
                        dataToChart={dataToChart}
                        endDayPortfolioPeriodSelected={endDayPortfolioPeriodSelected}
                        handleGroupByDistributionOptions={handleGroupByDistributionOptions}
                        totalLine={totalLine}
                        columnOrder={columnOrder}
                        setColumnOrder={setColumnOrder}
                    />
                </Route>
                <Route path={path.administrative.alocation.articles}>
                    <ArticlesTableTab
                        month={month}
                        assets={assetsWithNewValues}
                        isLoading={assetsLoading}
                        legislationArticles={legislationArticles}
                        setListLegislationArticles={setListLegislationArticles}
                        totalPortfolioBalance={totalPortfolioBalance}
                        totalArticlesBalance={totalArticlesBalance}
                        assetsByRule={assetsByRule} />
                </Route>
                <Route path={path.administrative.alocation.annotations}>
                    <CommentsTab assets={assetsWithNewValues}
                        isLoading={assetsLoading}
                        comments={comments}
                        setComments={setComments} />
                </Route>


            </Switch>

            <AddFundAlocationModal
                open={openAddFundAlocationModal}
                period={month && year ? getLastDayInMonthByMonthAndYear(month, year) : null}
                currentFundsIds={assetsWithNewValues?.length ? assetsWithNewValues.map(el => el.fund_id) : []}
                handleAction={(fund, application) => {
                    if (fund) {
                        handleAddNewFund(fund, application);
                    }
                    setOpenAddFundAlocationModal(false)
                }
                } />

        </div>

    )
}




